import { render, staticRenderFns } from "./StatusPorEmpresa.vue?vue&type=template&id=87188688&scoped=true"
import script from "./StatusPorEmpresa.vue?vue&type=script&lang=js"
export * from "./StatusPorEmpresa.vue?vue&type=script&lang=js"
import style0 from "./StatusPorEmpresa.vue?vue&type=style&index=0&id=87188688&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87188688",
  null
  
)

export default component.exports